import { BLAST_ERROR_LABELS, DRIP_ERROR_LABELS } from '../../constants';
export const NESTING_LIMIT = 10;
export const SMS_ALLOWED_BLOCKS = ['paragraph'];
export const NESTING_BLOCK_TYPES = ['two_column', 'card', 'conditional'];
export const ERROR_LABELS = {
    name_required: 'Name is required',
    invalid_name: 'Name must be at most 255 characters',
    missing_subject: 'A subject is required',
    invalid_subject: 'The subject must be text with no more than 255 characters',
    invalid_preheader: 'The preheader must be text with no more than 255 characters',
    library_requires_email: 'Library templates must use email',
    template_compile_failed: 'Template failed to compile',
    template_unknown_variable: 'Unknown variable in template',
    subject_unknown_variable: 'Unknown variable in subject line',
    variable_requires_target_kind: 'Variable requires a specific target kind',
    template_unsafe_html: 'Template contains unsafe HTML',
    template_render_failed: 'Template failed to render',
    template_invalid_block_structure: 'Invalid block structure',
    template_unknown_block_type: 'Unknown block type',
    template_missing_required_field: 'Missing required field in block',
    template_empty_required_field: 'Required field is empty',
    template_invalid_conditional_operator: 'Invalid conditional operator',
    template_invalid_link: 'Invalid link in template',
    profile_not_found: 'Profile not found',
    invalid_field_value: 'Invalid field value',
    invalid_variable_keys: 'Invalid variable keys provided',
    sms_template_invalid_block: 'SMS templates only support paragraph blocks',
    invalid_target_kind: 'Invalid target kind',
    invalid_target_type: 'Invalid template target',
    id_required: 'Template ID is required',
    variant_label_required: 'Variant label is required',
    variant_not_found: 'Variant not found',
    step_id_required: 'Step ID is required',
    step_not_found: 'Step not found',
    version_not_found: 'Drip version not found',
    template_not_found: 'Template not found',
    blast_not_found: 'Blast not found'
};
export const describeErrorCode = (code) => ERROR_LABELS[code] ?? BLAST_ERROR_LABELS[code] ?? DRIP_ERROR_LABELS[code] ?? code;
